import { render, staticRenderFns } from "./SectionTitleComponent.vue?vue&type=template&id=5393dd53&"
import script from "./SectionTitleComponent.vue?vue&type=script&lang=js&"
export * from "./SectionTitleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SectionTitleComponent.vue"
export default component.exports